// extracted by mini-css-extract-plugin
module.exports = {"appShell":"Confirmation-desktop-module__appShell___ent3X","bui-group--large":"Confirmation-desktop-module__bui-group--large___JIJSt"};